(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-mega-menu-item].is-open').forEach(function (item) {
      if (item !== except) {
        item.classList.remove('is-open');
        var link = item.querySelector('.main-nav__link');
        if (link) link.setAttribute('aria-expanded', 'false');
      }
    });
  }

  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-mega-menu-item]');
    if (item) {
      var link = item.querySelector('.main-nav__link');
      var hasMegaMenu = item.querySelector('.mega-menu');
      if (hasMegaMenu) {
        e.preventDefault();
        var isOpen = item.classList.contains('is-open');
        closeAll();
        if (!isOpen) {
          item.classList.add('is-open');
          if (link) link.setAttribute('aria-expanded', 'true');
        }
      }
      return;
    }
    closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
